import { createSelector } from "reselect";

import type {
  RelatedPublicSegment,
  RelatedPublicSegmentV4
} from "@busbud/core-types/dist/lib/poll-service/api/udm";

import { isNotNil } from "@app/helpers/is-not-nil";

import { getTripById } from "./get-trip";
import { getTripsSegments } from "../state-accessors";

export const getSegmentsWithSeatSelectionByTripId = createSelector(
  [getTripsSegments, getTripById],
  (segments, trip) => {
    // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    const segments_ids = trip.segment_ids;
    return segments_ids.reduce(
      (acc: (RelatedPublicSegment | RelatedPublicSegmentV4)[], segment_id) => {
        const segment = segments[segment_id];

        if (segment && isNotNil(segment.vehicle.layout)) {
          acc.push(segment);
        }

        return acc;
      },
      []
    );
  }
);
